// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment with the PaymentRequestButton using the official Stripe docs.
// https://stripe.com/docs/stripe-js/elements/payment-request-button#react

import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentRequestButtonElement, Elements, useStripe } from '@stripe/react-stripe-js';

import { Result, ErrorResult } from '../../helpers/utils';
import '../../styles/5 - components/_checkoutForm.scss';

const NotAvailableResult = () => (
  <Result>
    <div />
    {window.location.protocol !== 'https:' && (
      <p style={{ textAlign: 'center' }}>
        Try using
        {' '}
        <a href="https://ngrok.com" target="_blank" rel="noopener noreferrer">
          ngrok
        </a>
        {' '}
        to view this demo over https.
      </p>
    )}
  </Result>
);

const ELEMENT_OPTIONS = {
  style: {
    paymentRequestButton: {
      type: 'buy'
    }
  }
};

export const BrowserPayCheckout = ({ amount }) => {
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [notAvailable, setNotAvailable] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);

  useEffect(() => {
    if (!stripe) {
      // We can't create a PaymentRequest until Stripe.js loads.
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Donation Total',
        amount
      }
    });

    pr.on('paymentmethod', async (event) => {
      setPaymentMethod(event.paymentMethod);
      event.complete('success');
      alert('PLACEHOLDER (TO BE STYLED): Payment Received! Thank you!');
    });

    pr.canMakePayment().then((canMakePaymentRes) => {
      if (canMakePaymentRes) {
        setPaymentRequest(pr);
      } else {
        setNotAvailable(true);
      }
    });
  }, [stripe]);

  return (
    <div className="stripe">
      <form className='stripe'>
        {paymentRequest && (
          <PaymentRequestButtonElement
            onClick={(event) => {
              if (paymentMethod) {
                event.preventDefault();
                setErrorMessage(
                  'You can only use the PaymentRequest button once. Refresh the page to start over.'
                );
              }
            }}
            options={{
              ...ELEMENT_OPTIONS,
              paymentRequest
            }}
          />
        )}
        {notAvailable && <NotAvailableResult />}
        {errorMessage && <ErrorResult>{errorMessage}</ErrorResult>}
        {paymentMethod && (
          <Result>
            Got PaymentMethod:
            {paymentMethod.id}
          </Result>
        )}
      </form>
    </div>
  );
};
